import React, { useEffect, useState } from 'react'



export const Cart = ({ array, setArray }) => {

  const [amount, setamount] = useState(0)

  useEffect(() => {
    let amt = 0;
    if (amount < 0) {
      alert("Add number of items")
    } else {
      array.map((addingprice) => amt = (addingprice.count * addingprice.price) + amt)
      setamount(amt)
    }

  })
  const removecart = (cartlist) => {
    let removeshoe = array.filter((remshoe) => remshoe.id !== cartlist.id)
    setArray(removeshoe)
  }

  const placeorder = () => {
    alert("Your Order Placed Successfully")
  }

  const incrementitem = (data, num) => {
    let findposition = array.indexOf(data);
    array[findposition].count = array[findposition].count + num;
    setArray([...array])
  }
  return (
    <div>
      <div className='sidespace'>
        <div className='row '>
          <div className='col-lg-9 d-flex flex-wrap justify-content-evenly topheight'>

            {
              array.length <= 0 ? <h1 className='cartaddingtext'>Please Add Something To Cart</h1> : (
                <div className='d-flex flex-wrap'>
                  {
                    array.map((cartlist) =>
                      <div className='mx-3'>
                     
                          <div class="card cartbox">
                            <img src={cartlist.Image} class="card-img-top" alt="..." data-aos="flip-right"
                              data-aos-easing="ease-out-cubic"
                              data-aos-duration="2000" />
                            <div class="card-body">
                              <h5 class="card-title shoenametext" >{cartlist.shoename}</h5>
                              <p class="card-text priceamttext">{"MRP : ₹ "}{cartlist.price}</p>
                              <div className='increbtns'>
                                <p class='bx bxs-plus-circle plusbtn' onClick={() => incrementitem(cartlist, 1)} ></p>
                                <h4 className='countno'>{cartlist.count}</h4>
                                <p class='bx bxs-minus-circle plusbtn' onClick={() => incrementitem(cartlist, -1)}></p>
                                <div>
                                  <button className='removebtn' onClick={(() => removecart(cartlist))}>Remove</button>
                                </div>

                              </div>
                            </div>
                          </div>
                        
                      </div>

                    )
                  }
                </div>
              )
            }

          </div>

          <div className='placeorderbox col-lg-3'>
            <h3 className='pricedet'>Price Details</h3>
            <h4 className='priceamt'>Total Amount : ₹ {amount}</h4>
            <h6 className='paymentdet'>Payment Details</h6>

            <input type="checkbox" class="radiobox" />
            <label class="agreebox">Cash On Delivery</label>
           
            
            <h6 className='paymentdet'>Shipping Details</h6>
            <input type="text" placeholder='Address' className='adressdeetails' />
            <button className='orderbtn' onClick={() => placeorder()}>Place Order</button>


          </div>

        </div>
      </div>
      <section className='footerbox'>
        <div className='sidespace'>
          <div className='rowflex'>
            <div>
              <img src="./images/jordanlogo.png" alt="" className='footerlogo' />
              <p className='footerpara'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, saepe dolor. Exercitationem commodi eveniet accusantium deserunt ex cumque. ter impedit atque consectetur </p>
              <p className='mailheading'>Receive mail at your mail</p>
              <div className='inputflex'>
                <input type="text" placeholder='Mail id' className='inputbox' />
                <button className='sendbox'>Send</button>
              </div>

            </div>
            <div>
              <h5 className='secondrow'>Products</h5>
              <p className='footersecondrow'>Running shoe</p>
              <p className='footersecond'>Sports shoe</p>
              <p className='footersecond'>Formal shoe</p>
              <p className='footersecond'>Causal shoe</p>
              <p className='footersecond'>Sneakers shoe</p>
            </div>
            <div>
              <h5 className='secondrow'>Support</h5>
              <p className='footersecondrow'>Privacy Policy</p>
              <p className='footersecond'>Terms & Condition</p>
              <p className='footersecond'>Cookies settings</p>
              <p className='footersecond'>Contact us</p>
              <p className='footersecond'>Customer care</p>


            </div>
            <div>
              <h5 className='secondrow'>Contacts</h5>
              <div className='phoneflex'>
                <p class='bx bx-phone-call footerphone' ></p>
                <p className='footernumber'> +99 98564 63277</p>
              </div>
              <div className='mailflex'>
                <p class='bx bx-envelope footerphone' ></p>
                <p className='footernumber'> shoelace@gmail.com</p>
              </div>
              <div className='mailflex'>
                <p class='bx bx-map footerphone' ></p>
                <p className='footernumber'> 27 B benseroad <br />Newyork USA</p>
              </div>
            </div>
          </div>
          <hr className='footerline' />
          <div className='downfooterflex'>
            <div className='dfone'>
              <img src="./images/paymentcard.png" alt="" className='paymentone' />
              <p className='copyright'>Copyright@Dpdesigner/2023</p>
            </div>
            <div className='dftwo'>
              <img src="./images/smtwo.png" alt="" className='paymenttwo' />
              <p className='copyright'>All Rights Reserved</p>
            </div>
          </div>


        </div>
      </section>
    </div>
  )
}
